import Vue from "vue";
import Router from "vue-router";

//admin
import AdminLayout from "@/components/admin/layout/Layout";
//adminmain
import AdminMain from "@/components/admin/Main";

//System management
import User from "@/components/admin/management/User";
import Role from "@/components/admin/management/Role";

// user management
import userDetail from "@/components/admin/userManagement/userDetail";
import UserList from "@/components/admin/userManagement/userList";
import GroupPortrait from "@/components/admin/userManagement/GroupPortrait";

// unversity、School
import universityList from "@/components/admin/university/UniversityList";
import UniversityListDetail from "@/components/admin/university/UniversityListDetail";
import RinkingUniversity from "@/components/admin/university/RinkingUniversity";

// scholar、person
import ScholarList from "@/components/admin/scholar/ScholarList";
import ScholarDetail from "@/components/admin/scholar/ScholarDetail";

// bpManager
import BestPracticeList from "@/components/admin/bestPractice/BestPracticeList";
import BestPracticeDetail from "@/components/admin/bestPractice/BestPracticeDetail";
import AwardsList from "@/components/admin/bestPractice/AwardsList";

// lecture management
import LectureList from "@/components/admin/lecture/LectureList";
import LectureDetail from "@/components/admin/lecture/LectureDetail";
import LectureBanner from "@/components/admin/lecture/LectureBanner";
import SeriesDetail from "@/components/admin/lecture/SeriesDetail";
import thesaurusManagement from "@/components/admin/content/thesaurusManagement";

//System content
import BannerManage from "@/components/admin/content/BannerManage";
import RichText from "@/components/admin/content/RichText";

// guihua
import newMagazine from "@/components/admin/guihua/newMagazine";
import newMagazineDetail from "@/components/admin/guihua/NewMagazineDetail";
import magazineBanner from "@/components/admin/guihua/magazineBanner";
import magazineScholarList from "@/components/admin/guihua/MagazineScholarList";
import magazineRichText from "@/components/admin/guihua/components/magazineRichText";
import magazineArticleDetail from "@/components/admin/guihua/MagazineArticleDetail";
import newsLatterList from "@/components/admin/guihua/newsLatterList";
import newsLatterDetail from "@/components/admin/guihua/newsLatterDetail";

//System competition
// import CompetitionList from "@/components/admin/competition/competition/CompetitionList";
// import CompetitionDetail from "@/components/admin/competition/competitionDetail/CompetitionDetail";
// import CompetitionWork from "@/components/admin/competition/competitionWork/CompetitionWork";
// import CompetitionWorkDetail from "@/components/admin/competition/competitionWorkDetail/CompetitionWorkDetail";
import newCompetitionList from "@/components/admin/competition/NewCompetitionList";
import newCompetitionDetail from "@/components/admin/competition/NewCompetitionDetail";
import newCompetitionWork from "@/components/admin/competition/NewCompetitionWorkList";
import newCompetitionWorkDetail from "@/components/admin/competition/NewCompetitionWorkDetail";

// 前沿动态  exploration  ExplorationList
import ExplorationList from "@/components/admin/exploration/ExplorationList";
import ExplorationDetail from "@/components/admin/exploration/ExplorationDetail";

//词条
import EntryList from "@/components/admin/entry/EntryList";
import EntryDetail from "@/components/admin/entry/EntryDetail";


// iHeritage
import HeritageList from "@/components/admin/iHeritage/HeritageList";
import HeritageDetail from "@/components/admin/iHeritage/HeritageDetail";
import HeritageCity from "@/components/admin/iHeritage/cityManagement";

//展馆
import ExhibitionList from "@/components/admin/exhibition/ExhibitionList";
import ExhibitionDetail from "@/components/admin/exhibition/ExhibitionDetail";
import WorksList from "@/components/admin/exhibition/WorksList";
import WorksDetail from "@/components/admin/exhibition/WorksDetail";
import OtherList from "@/components/admin/exhibition/OtherList";
import BaseDetail from "@/components/admin/exhibition/BaseDetail";

//System configurations
import Dictionary from "@/components/admin/configuration/Dictionary";
import UserDictionary from "@/components/admin/configuration/UserDictionary";
import CompetitionDictionary from "@/components/admin/configuration/CompetitionDictionary";
import API from "@/components/admin/configuration/API";
import Test from "@/components/admin/configuration/Test";
import AdminLogin from "@/components/admin/Login";


// Wupen map
import CityList from "@/components/admin/map/cityList";
import CityDetail from "@/components/admin/map/CityDetail";
import RegionList from "@/components/admin/map/regionList";
import RegionDetail from "@/components/admin/map/regionDetail";

//news
import NewsList from "@/components/admin/news/News";
import NewsDetail from "@/components/admin/news/NewsDetail";

// comment 
import UrbanDream from "@/components/admin/audit/urbanDream";


const originalPush = Router.prototype.push;
console.log('查看路由', originalPush)
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
Vue.use(Router);

import cookie from 'js-cookie';
const router = new Router({
  // mode: "history",
  routes: [
    {
      path: "/admin",
      name: "Admin",
      component: AdminLayout,
      children: [
        {
          path: "/admin/main",
          component: AdminMain,
          name: "AdminMain",
          meta: { permission: 'a1' }
        },
        // 用户
        {
          path: "/admin/userdetail",
          component: userDetail,
          name: "userDetail",
          meta: { permission: 'a1' }
        },
        {
          path: "/admin/userlist",
          component: UserList,
          name: "UserList",
          meta: { permission: 'a1' }
        },
        {
          path: "/admin/groupPortrait",
          component: GroupPortrait,
          name: "GroupPortrait",
          meta: { permission: 'a1' }
        },
        // {
        //   path: "/admin/user",
        //   component: User,
        //   name: "User",
        //   meta:{permission:'a1'}
        // },
        // 院校管理
        {
          path: "/admin/school",
          component: universityList,
          name: "school",
          meta: { permission: 'a2' }
        },
        {
          path: "/admin/schooldetail",
          component: UniversityListDetail,
          name: "schooldetail",
          meta: { permission: 'a2' }
        },
        {
          path: "/admin/rinkingschool",
          component: RinkingUniversity,
          name: "rinkingschool",
          meta: { permission: 'a2' }
        },
        // {
        //   path: "/admin/universityrank",
        //   component: UniversityRank,
        //   name: "UniversityRank",
        //   meta:{permission:'a2'}
        // },
        // {
        //   path: "/admin/university",
        //   component: UniversityList,
        //   name: "University",
        //   meta:{permission:'a2'}
        // },
        // 学者管理
        {
          path: "/admin/scholarlist",
          component: ScholarList,
          name: "scholarlist",
          meta: { permission: 'a3' }
        },
        {
          path: "/admin/scholardetail",
          component: ScholarDetail,
          name: "scholardetail",
          meta: { permission: 'a3' }
        },
        // {
        //   path: "/admin/person",
        //   component: Person,
        //   name: "Person",
        //   meta:{permission:'a3'}
        // },

        //课程管理
        {
          path: "/admin/lecture",
          component: LectureList,
          name: "lecture",
          meta: { permission: 'a4' }
        },
        {
          path: "/admin/seriesdetail",
          component: SeriesDetail,
          name: "seriesdetail",
          meta: { permission: 'a4' }
        },
        {
          path: "/admin/lecturebanner",
          component: LectureBanner,
          name: "lecturebanner",
          meta: { permission: 'a4' }
        },


        {
          path: "/admin/lecturedetail",
          component: LectureDetail,
          name: "lecturedetail",
          meta: { permission: 'a4' }
        },

        // map
        {
          path: "/admin/cityList",
          component: CityList,
          name: "cityList",
          meta: { permission: 'a5' }
        },
        {
          path: "/admin/cityDetail",
          component: CityDetail,
          name: "cityDetail",
          meta: { permission: 'a5' }
        },
        {
          path: "/admin/regionList",
          component: RegionList,
          name: "regionList",
          meta: { permission: 'a5' }
        },
        {
          path: "/admin/regionDetail",
          component: RegionDetail,
          name: "regionDetail",
          meta: { permission: 'a5' }
        },

        // 前沿动态
        {
          path: "/admin/explorationlist",
          component: ExplorationList,
          name: "explorationlist",
          meta: { permission: 'a6' }
        },
        {
          path: "/admin/explorationdetail",
          component: ExplorationDetail,
          name: "explorationdetail",
          meta: { permission: 'a6' }
        },
        // bp管理
        {
          path: "/admin/bestpractice",
          component: BestPracticeList,
          name: "bestpractice",
          meta: { permission: 'a7' }
        },
        {
          path: "/admin/bestpracticedetail",
          component: BestPracticeDetail,
          name: "bestpracticedetail",
          meta: { permission: 'a7' }
        },
        {
          path: "/admin/awardslist",
          component: AwardsList,
          name: "awardslist",
          meta: { permission: 'a7' }
        },
        //竞赛管理
        // {
        //   path: "/admin/competition",
        //   component: Competition,
        //   name: "Competition",
        //   meta:{permission:'a8'}
        // },
        // {
        //   path: "/admin/competitionentry",
        //   component: CompetitionEntry,
        //   name: "CompetitionEntry",
        //   meta:{permission:'a8'}
        // },
        // {
        //   path: "/admin/competitionlist",
        //   component: CompetitionList,
        //   name: "CompetitionList",
        //   meta: { permission: 'a8' }
        // },
        // {
        //   path: "/admin/competitiondetail",
        //   component: CompetitionDetail,
        //   name: "Competitiondetail",
        //   meta: { permission: 'a8' }
        // },
        // {
        //   path: "/admin/competitionwork",
        //   component: CompetitionWork,
        //   name: "CompetitionWork",
        //   meta: { permission: 'a8' }
        // },
        // {
        //   path: "/admin/competitionworkdetail",
        //   component: CompetitionWorkDetail,
        //   name: "CompetitionWorkDetail",
        //   meta: { permission: 'a8' }
        // },
        {
          path: "/admin/newCompetitionList",
          component: newCompetitionList,
          name: "newCompetitionList",
          meta: { permission: 'a8' }
        },
        {
          path: "/admin/newCompetitionDetail",
          component: newCompetitionDetail,
          name: "newCompetitionDetail",
          meta: { permission: 'a8' }
        },
        {
          path: "/admin/newCompetitionWork",
          component: newCompetitionWork,
          name: "newCompetitionWork",
          meta: { permission: 'a8' }
        },
        {
          path: "/admin/newCompetitionWorkDetail",
          component: newCompetitionWorkDetail,
          name: "newCompetitionWorkDetail",
          meta: { permission: 'a8' }
        },
        //新闻
        {
          path: "/admin/news",
          component: NewsList,
          name: "News",
          meta: { permission: 'a9' }
        },
        {
          path: "/admin/newsdetail",
          component: NewsDetail,
          name: "newsdetail",
          meta: { permission: 'a9' }
        },
        // {
        //   path: "/admin/news",
        //   component: News,
        //   name: "news",
        //   meta:{permission:'a9'}
        // },

        //guihua
        // {
        //   path: "/admin/magazine",
        //   component: Magazine,
        //   name: "Magazine",
        //   meta:{permission:'b1'}
        // },
        {
          path: "/admin/newMagazine",
          component: newMagazine,
          name: "newMagazine",
          meta: { permission: 'b1' }
        },
        {
          path: "/admin/newMagazineDetail",
          component: newMagazineDetail,
          name: "newMagazineDetail",
          meta: { permission: 'b1' }
        },
        {
          path: "/admin/magazineBanner",
          component: magazineBanner,
          name: "magazineBanner",
          meta: { permission: 'b1' }
        },
        {
          path: "/admin/magazineScholarList",
          component: magazineScholarList,
          name: "magazineScholarList",
          meta: { permission: 'b1' }
        },
        {
          path: "/admin/magazineRichText",
          component: magazineRichText,
          name: "magazineRichText",
          meta: { permission: 'b1' }
        },
        {
          path: "/admin/newsLatterList",
          component: newsLatterList,
          name: "newsLatterList",
          meta: { permission: 'b1' }
        },
        {
          path: "/admin/newsLatterDetail",
          component: newsLatterDetail,
          name: "newsLatterDetail",
          meta: { permission: 'b1' }
        },
        {
          path: "/admin/magazineArticleDetail",
          component: magazineArticleDetail,
          name: "MagazineArticleDetail",
          meta: { permission: 'b1' }
        },




        // 内容审核
        {
          path: "/admin/urbanDream",
          component: UrbanDream,
          name: "urbanDream",
          meta: { permission: 'b2' }
        },
        // 岗位管理
        // {
        //   path: "/admin/job",
        //   component: Job,
        //   name: "Job",
        //   meta:{permission:'b3'}
        // },
        {
          path: "/admin/bannerManage",
          component: BannerManage,
          name: "BannerManage",
          meta: { permission: 'b4' }
        },
        {
          path: "/admin/thesaurusManagement",
          component: thesaurusManagement,
          name: "thesaurusManagement",
          meta: { permission: 'b4' }
        },
        // 词条
        {
          path: "/admin/entryList",
          component: EntryList,
          name: "EntryList",
          meta: { permission: 'b7' }
        },
        {
          path: "/admin/entryDetail",
          component: EntryDetail,
          name: "EntryDetail",
          meta: { permission: 'b7' }
        },

        // iheritage
        {
          path: "/admin/heritageDetail",
          component: HeritageDetail,
          name: "HeritageDetail",
          meta: { permission: 'c1' }
        },
        {
          path: "/admin/heritageList",
          component: HeritageList,
          name: "HeritageList",
          meta: { permission: 'c1' }
        },
        {
          path: "/admin/heritageCityManagement",
          component: HeritageCity,
          name: "HeritageCity",
          meta: { permission: 'c1' }
        },

        {
          path: "/admin/exhibitionList",
          component: ExhibitionList,
          name: "ExhibitionList",
          meta: { permission: 'b4' }
        },
        {
          path: "/admin/exhibitionDetail",
          component: ExhibitionDetail,
          name: "ExhibitionDetail",
          meta: { permission: 'b4' }
        },
        {
          path: "/admin/worksList",
          component: WorksList,
          name: "WorksList",
          meta: { permission: 'b4' }
        },
        {
          path: "/admin/worksDetail",
          component: WorksDetail,
          name: "WorksDetail",
          meta: { permission: 'b4' }
        },
        {
          path: "/admin/otherList",
          component: OtherList,
          name: "OtherList",
          meta: { permission: 'b4' }
        },
        {
          path: "/admin/baseDetail",
          component: BaseDetail,
          name: "BaseDetail",
          meta: { permission: 'b4' }
        },


        /////////////////////////////////////////////////////////////////////////////// 有待完善
        {
          path: "/admin/richtext",
          component: RichText,
          name: "RichText",
          meta: { permission: 'a1' }
        },
        {
          path: "/admin/dictionary",
          component: Dictionary,
          name: "Dictionary",
          meta: { permission: 'a1' }
        },
        {
          path: "/admin/userdictionary",
          component: UserDictionary,
          name: "UserDictionary",
          meta: { permission: 'a1' }
        },
        {
          path: "/admin/competitiondictionary",
          component: CompetitionDictionary,
          name: "CompetitionDictionary",
          meta: { permission: 'a1' }
        },
        /////////////////////////////////////////////////////////////////////////////// 有待完善

      ],
    },
    {
      path: "/admin/login",
      component: AdminLogin,
      name: "AdminLogin",
    },
    {
      path: "/",
      redirect: "/admin/login",
    },
    {
      path: "/admin/index",
      redirect: "/admin/login",
    },
  ],
});


router.beforeEach(function (to, from, next) {
  if (to.name == 'AdminLogin') {
    next()
  } else {
    if (!cookie.get('au')) {
      next('/admin/login')
    }

    if (to.name == 'AdminMain') {

      next()

    } else {
      if (to.meta.permission && JSON.parse(localStorage.getItem('icpermission')).find(item => item.module_id == to.meta.permission)) {
        next()
      }
      else {
        next('/admin/main')
      }
    }

  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js